import DeliveryFollowUp from './DeliveryFollowUp'

export default DeliveryFollowUp
